<template>
  <div>
    <el-dialog title="选择商品标准库"
               :visible.sync="dialogVisible"
               width="650px"
               @close="closeModel">
      <div class="main">
        <span>请选择商品标准库：</span>
        <el-autocomplete v-model="keyword"
                         style="width: 480px"
                         :fetch-suggestions="querySearchAsync"
                         @select="handleSelect"
                         placeholder="请输入关键字检索"
                         clearable></el-autocomplete>
        <!--  <el-cascader
                    collapse-tags
                    style="width: 480px"
                    filterable
                    clearable
                    :props="{ value: 'id', label: 'name', expandTrigger: 'hover', multiple: true }"
                    v-model="category"
                    :options="category_options"
                ></el-cascader> -->
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      dialogVisible: true,
      keyword: '',
      category: [],
      type: this.$route.params.type,
      restaurants: [],
      item:{}
    };
  },
  props: ['shop_id'],
  mounted () {
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    closeModel () {
      this.$emit("closeModel");
    },
    ...mapActions({
      standardList: "detect/standardList",

    }),
    /**standardList */
    querySearchAsync (queryString, cb) {
      if (queryString !== '') {
        let params = {
          keyword: queryString,
          token: this.getToken,
        }
        let restaurants = []
        this.standardList(params).then(res => {
          if (res.data.code == 1) {
           res.data.data.forEach(el => {
             let obj = {
               value:el.name,
               id:el.standard_id
             }
              restaurants.push(obj)
            });
            let results =  restaurants.filter(this.createStateFilter(queryString)) 
             cb(results);
          }else{
             restaurants = []
              cb(restaurants);
          }
        })
      }
    },
    createStateFilter (queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    //@select="handleSelect"  是选中某一列触发的事件,在这里item为选中字段所在的对象
    handleSelect (item) {
      this.item =item
    },
    submit () {
      console.log( this.item,' this.item')
      if ( JSON.stringify(this.item)== '{}') {
        
        this.$message.error('请选择');
      }else{
         this.$emit("selectListFunc",  this.item);
        this.closeModel();
      }
      
    },
   /*  handleClose() {
        this.dialogVisible = false;
        this.category = [];
    }, */
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 200px;
}
/*   ::v-deep .el-cascader-panel {
.el-scrollbar:first-child {
 .el-checkbox {
      display: none;
    }
  } */
::v-deep .el-scrollbar:nth-child(2) {
  .el-checkbox {
    display: none;
  }
}
</style>